module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetHigh@2x.9e0af0e.jpg";